import {
  createVenueOwner,
  getVenueBased,
  saveVenueDocument,
  sendOtpEmail,
  signInVenue,
  verifyOtp,
} from './ApiEndPoint'
import { baseApiCall } from './BaseApiCall'

export const postApiSignInVenue = data => {
  return baseApiCall({
    url: signInVenue,
    method: 'post',
    data
  })
}

export const postApiCreateVenueOwner = data => {
  return baseApiCall({
    url: createVenueOwner,
    method: 'post',
    data
  })
}


export const postApiSendOtpEmail = data => {
  return baseApiCall({
    url: sendOtpEmail,
    method: 'post',
    data
  })
}

export const postApiVerifyOtp = data => {
  return baseApiCall({
    url: verifyOtp,
    method: 'post',
    data
  })
}




export const postApiVenueBased = data => {
  return baseApiCall({
    url: getVenueBased,
    method: 'post',
    data
  })
}

export const postSaveVenueDocument = data => {
  return baseApiCall({
    url: saveVenueDocument,
    method: 'post',
    data
  })
}
